import React, { Component } from 'react';
import icons from '../../assets/images/icons_34.png';
import IconSet from './IconSet';

class IconSet34 extends Component {
  render() {
    const items = ['login', 'top', 'bottom', 'topDemo', 'bottomDemo'];
    const sets = { 'size_34': icons};
    // if (!this.props.menuSize) return <span/>
    return <IconSet items={items} sets={sets} {...this.props} />

  }
}

export default IconSet34;



// WEBPACK FOOTER //
// ./src/components/Icon/IconSet34.jsx